import React from "react";
import { Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";


import {
  deleteCategory
} from "appRedux/actions/StoreCoupons";

import {
  fetchCategories
} from "appRedux/actions/Coupons";


class ModalDelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    }
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };



  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'La categoría se ha eliminado con éxito.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al registrar la categoría.',
      });
    }
  };

  onHandleClick = () => {
    this.props.deleteCategory(this.props.recording, () => { this.props.fetchCategories(); });
    this.onNotification('success');
  }

  onHandleCancel = () => {
    this.props.fetchCategories();
    this.setState({ visible: false });
  }

  render() {

    return (
      <div>
        <Button type="danger" onClick={this.showModal}><i className="icon icon-trash" /></Button>
        <Modal
          okText="Borrar"
          cancelText="Salir"
          title="Borrar"
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.onHandleCancel}
        >
          <p>Está seguro de eliminar la categoría {this.props.recording.name}?</p>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ placeStores }) {
  return {
    placeStores,
  }
}

export default connect(mapStateToProps, { deleteCategory, fetchCategories })(ModalDelete);



// WEBPACK FOOTER //
// ./src/routes/main/Cupons/Category/ModalDelete.js